export default __webpack_public_path__ + "static/media/christmasLogo.4345496a.png";